import { generateUuid } from '@shared/lib'

export const clientId = process.env.NEXT_PUBLIC_CLIENT_ID as string

export const ICON_TCP = 'https://staticpayment.ssl.mts.ru/prov-icons/'

export const GAMES_URL = 'https://payment.mts.ru/categories/games'

export const NEW_CARD_URL =
  'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/?utm_source=payment&utm_medium=promo&utm_campaign=cashback30&utm_content=cyber'

export const CONTRACT_URL =
  'https://static.mts.ru/uploadmsk/contents/1655/soglashenie_easy_pay.pdf?_ga=1.125490114.915762629.1465198111'

export const CONDITIONS_URL = 'https://static.ssl.mts.ru/mts_rf/images/usloviya-edinogo-dostupa-k-servisam-MTS.html'

export const CASHBACK_URL = 'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/'

export const MAIN_PATH = 'https://payment.mts.ru/cyber'

export const MESSAGE_COMMISSION = 'Ошибка расчета комиссии, попробуйте снова'

export const MESSAGE_NO_MTS_CARD = 'Не карта МТС банка'

export const MESSAGE_PAYMENT_ERROR = 'Ошибка оплаты'

export const MESSAGE = 'Ошибка при получении данных'

export const MESSAGE_INARIUS = 'Ошибка при регистрации телефона'

export const MESSAGE_REVIEW = 'Ошибка при отправке отзыва'

export const MESSAGE_QR = 'Ошибка при генерации QR Code'

export const MESSAGE_PROMOCODE_ACTIVATED = 'Промокод применён'

export const MESSAGE_ERROR_PROMOCODE = 'Ошибка активации промокода'

export const MESSAGE_ERROR = 'Произошла ошибка. Попробуйте позже'

export const MESSAGE_ERROR_PROMOCODE_NOT_FOUND = 'Промокод не найден'

export const MESSAGE_QR_DUBLICATE =
  'QR-код был использован ранее. Обновите страницу, чтобы получить новый код для оплаты'

export const MESSAGE_QR_VPN =
  'Похоже, что у вас включен VPN. Отключите его, закройте вкладку с\u00A0нашим сайтом и откройте её снова, затем попробуйте оплатить ещё раз.'

export const STEAM_COURSE = 'Не удалось рассчитать сумму'

export const MESSAGE_QR_STEAM = 'Не можем пополнить данный аккаунт. Проверьте корректность введенных данных'

export const MESSAGE_NO_WORK_SERVICE = 'Сервис временно не работает'

export const MESSAGE_QR_STATUS = 'Ошибка получения статуса оплаты'

export const MESSAGE_QR_STATUS_NOT_FOUND = 'Платеж не найден'

export const ERROR_MESSAGE_CHECK = 'Не удалось скачать чек операции, повторите попытку позже.'

export const CYBER_PAY_URL_RESULT = 'cyber/result/:mdOrder'

export const CYBER_PAY_URL_RESULT_SBP = 'cyber/resultSBP/:qrcId'

export const CARD_MIR =
  'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/?utm_source=payment&utm_medium=promo&utm_campaign=cashback30&utm_content=cyber'

export const FULL_TERMS = 'https://staticpayment.ssl.mts.ru/upload/cashback_for_paying_for_foreign_services.pdf'

export const RULES_OF_THE_PROMOTION =
  'https://staticpayment.ssl.mts.ru/upload/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0_%D0%B0%D0%BA%D1%86%D0%B8%D0%B8_%D0%92%D0%B5%D1%81%D0%B5%D0%BD%D0%BD%D0%B8%D0%B8%CC%86_%D1%80%D0%BE%D0%B7%D1%8B%D0%B3%D1%80%D1%8B%D1%88_%D0%BF%D1%80%D0%B8%D0%B7%D0%BE%D0%B2__%D0%94%D0%9F_.pdf'

export const FULL_LIST_USERS = 'https://staticpayment.ssl.mts.ru/upload/List_of_participants_for_inarius_draws.pdf'

export const FULL_LIST_USERS_NY_ITOGI_500 =
  'https://staticpayment.ssl.mts.ru/upload/pobediteli_garantirovannogo_priza_500rub.pdf'

export const FULL_LIST_USERS_NY_ITOGI_1000 =
  'https://staticpayment.ssl.mts.ru/upload/pobediteli_garantirovannogo_priza_1000rub.pdf'

export const FULL_LIST_USERS_NY_ITOGI =
  'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_rozygrysha_glavnykh_prizov.pdf'
export const FULL_LIST_USERS_VESENNEGO_ROZYGRISHA =
  'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_vesennego_rozygrysha.pdf'
export const FULL_LIST_USERS_PAY_QR = 'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_pay_qr.pdf'
export const FULL_LIST_USERS_PUBG_GIVEAWAY =
  'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_pubg_giveaway.pdf'
export const FULL_LIST_USERS_NEW_YEAR_GIVEAWAY =
  'https://staticpayment.ssl.mts.ru/upload/%D0%A1%D0%BF%D0%B8%D1%81%D0%BE%D0%BA_%D1%83%D1%87%D0%B0%D1%81%D1%82%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2_%D0%97%D0%B8%D0%BC%D0%BD%D0%B5%D0%B3%D0%BE_%D1%80%D0%BE%D0%B7%D1%8B%D0%B3%D1%80%D1%8B%D1%88%D0%B0_%D0%BF%D1%80%D0%B8%D0%B7%D0%BE%D0%B2_%D0%BD%D0%B0_Steam.pdf'
export const WINNER_LIST_NEW_YEAR_GIVEAWAY =
  'https://staticpayment.ssl.mts.ru/upload/%D0%A1%D0%BF%D0%B8%D1%81%D0%BE%D0%BA_%D0%BF%D0%BE%D0%B1%D0%B5%D0%B4%D0%B8%D1%82%D0%B5%D0%BB%D0%B5%D0%B8%CC%86_%D0%97%D0%B8%D0%BC%D0%BD%D0%B5%D0%B3%D0%BE_%D1%80%D0%BE%D0%B7%D1%8B%D0%B3%D1%80%D1%8B%D1%88%D0%B0_%D0%BF%D1%80%D0%B8%D0%B7%D0%BE%D0%B2_%D0%BD%D0%B0_Steam.pdf'

export const DVOINOI_SHANS_NA_POBEDU_TERMS =
  'https://staticpayment.ssl.mts.ru/upload/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0_%D0%B0%D0%BA%D1%86%D0%B8%D0%B8_%D0%94%D0%B2%D0%BE%D0%B8%CC%86%D0%BD%D0%BE%D0%B8%CC%86_%D1%88%D0%B0%D0%BD%D1%81_%D0%BD%D0%B0_%D0%BF%D0%BE%D0%B1%D0%B5%D0%B4%D1%83_2026__%D0%94%D0%9F_.pdf'

export const OSENNII_ROZYGRYSH_PRIZOV_2026_TERMS =
  'https://staticpayment.ssl.mts.ru/upload/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0_%D0%B0%D0%BA%D1%86%D0%B8%D0%B8_%D0%9E%D1%81%D0%B5%D0%BD%D0%BD%D0%B8%D0%B8%CC%86_%D1%80%D0%BE%D0%B7%D1%8B%D0%B3%D1%80%D1%8B%D1%88_%D0%BF%D1%80%D0%B8%D0%B7%D0%BE%D0%B2_%D0%BD%D0%B0_Steam_2026__%D0%94%D0%9F_.pdf'

export const STATIC_STEAM_ICON = 'https://staticpayment.ssl.mts.ru/upload/steam-icon.svg'

export const MINCIFRY_CERTIFICATES_URL = 'https://www.gosuslugi.ru/crt'

export const INSTRUCTIONS = 'https://www.mtsbank.ru/chastnim-licam/vse-servici/mtsdengi-apk/'

export const PREMIUM = 'https://premium.mts.ru/'

export const APP_STORE =
  'https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BA%D0%BE%D1%88%D0%B5%D0%BB%D0%B5%D0%BA/id6450266264'

export const CYBER_URL = '/cyber'

export const STEAM_URL = '/cyber/steam'

export const MTS_FOG_PLAY = 'https://fogplay.mts.ru/?code=STEAMPAY15&utm_source=mtspayment&utm_medium=promocode'

export const FINAL_TOURNAMENT = 'https://vkvideo.ru/playlist/-112288603_-2/video-112288603_456242487'

export const MTS_TOURNAMENT = 'https://lnk.bio/MTS_Oplata'

export const categoryRequestParams = {
  requestId: generateUuid(),
  id: null,
  categoryName: 'comeback',
  showHidden: true,
  showFromHiddenCategories: true,
}

export const ewalletReqHeaders = {
  'Client-Id': clientId,
}

export const reqHeaders = {
  'Client-Id': clientId as unknown as string,
  'Content-Type': 'application/json',
}

export const reqHeadersQR = {
  'X-Request-ID': generateUuid(),
  ...reqHeaders,
}

export const DELAY = 300
